import React, { useState, useEffect, memo } from "react";
import Modal from "react-modal";
import ApiCall from "../../services/apiCall";
import { useSelector } from "react-redux";

const customStyles = {
  overlay: {
    position: "fixed",
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  content: {
    zIndex: 1001,
  },
};

Modal.setAppElement(document.getElementById("root"));

const matchesFilterSearch = (label, query) =>
  `${label || ""}`
    .toLowerCase()
    .includes(`${query || ""}`.trim().toLowerCase());

const FilterComp = ({
  isModalOpen,
  closeModal,
  onPressApply = () => {},
  onPressCancel = () => {},
  isArtistFilter,
  isEventFilter,
  selectedFilter,
}) => {
  const selectedCity = useSelector((state) => state.citySelector.selectedCity);
  const userBaseCity = useSelector((state) => state.citySelector.userBaseCity);

  const [searchLocality, setSearchLocality] = useState("");
  const [searchGenre, setSearchGenre] = useState("");
  const [localities, setLocalities] = useState([]);
  const [generes, setGeneres] = useState([]);
  const [happyHourTimings, setHappyHourTimings] = useState(
    selectedFilter?.happyHours || ""
  );
  const [kidsFriendly, setKidsFriendly] = useState(
    selectedFilter?.kidsFriendly || ""
  );
  const [vegNonVeg, setVegNonVeg] = useState(selectedFilter?.vegNonVeg || "");
  const [stages, setStages] = useState(selectedFilter?.stagsAllowed || "");
  const [sheesha, setSheesha] = useState(selectedFilter?.sheesha || "");
  const [artist, setArtist] = useState(selectedFilter?.artist || "");
  const [liveMusicDj, setLiveMusicDj] = useState(
    selectedFilter?.liveMusicDj || ""
  );
  const [artistType, setArtistType] = useState(
    selectedFilter?.artistType || ""
  );
  const [selectAllLocality, setSelectAllLocality] = useState(false);
  const [selectAllGenre, setSelectAllGenre] = useState(false);

  useEffect(() => {
    setHappyHourTimings(selectedFilter?.happyHours || "");
    setKidsFriendly(selectedFilter?.kidsFriendly || "");
    setVegNonVeg(selectedFilter?.vegNonVeg || "");
    setStages(selectedFilter?.stagsAllowed || "");
    setSheesha(selectedFilter?.sheesha || "");
    setArtist(selectedFilter?.artist || "");
    setLiveMusicDj(selectedFilter?.liveMusicDj || "");
    setArtistType(selectedFilter?.artistType || "");
  }, [selectedFilter]);

  useEffect(() => {
    let isMounted = true;
    
    const filterApi = async () => {
      if (!selectedCity) {
        setLocalities([]);
        setGeneres([]);
        return;
      }

      try {
        const res = await ApiCall(
          `api/filters?city=${encodeURIComponent(selectedCity)}`,
          "GET"
        );
        
        if (!isMounted) return;

        const activeLocalities = selectedFilter?.locality || [];
        const activeGenres = selectedFilter?.musicGenre || [];

        const uniqueArray = res?.data?.localities?.map((item) => {
          const foundLocality = activeLocalities.find(
            (locality) => locality.value == item.value
          );
          if (foundLocality) {
            return foundLocality;
          }
          return item;
        });

        setLocalities(uniqueArray || []);

        const tempGenre = !isArtistFilter
          ? res?.data?.generes
          : res?.data?.artistsMusicGenres;

        const uniqueGenre = tempGenre?.map((item) => {
          const foundGenre = activeGenres?.find(
            (genre) => genre.value == item.value
          );
          if (foundGenre) {
            return foundGenre;
          }
          return item;
        });
        setGeneres(uniqueGenre || []);
      } catch (error) {
        if (isMounted && typeof Toast !== 'undefined') {
          Toast.showWithGravity(error?.message, Toast.LONG, Toast.BOTTOM);
        }
      }
    };

    filterApi();
    
    return () => {
      isMounted = false;
    };
  }, [isArtistFilter, isEventFilter, selectedCity, userBaseCity, selectedFilter]);

  // select all localities
  useEffect(() => {
    const temp = localities?.map((item) => {
      return { ...item, checked: selectAllLocality };
    });
    if (temp?.length) setLocalities(temp);
  }, [selectAllLocality]);

  // select all genres
  useEffect(() => {
    const genre = generes?.map((item) => {
      return { ...item, checked: selectAllGenre };
    });
    if (genre?.length) setGeneres(genre);
  }, [selectAllGenre]);

  const clearLocalities = () => {
    const temp = localities?.map((item) => {
      return { ...item, checked: false };
    });
    setLocalities(temp);
    setSelectAllLocality(false);
  };
  const clearGeneres = () => {
    const temp = generes?.map((item) => {
      return { ...item, checked: false };
    });
    setGeneres(temp);
    setSelectAllGenre(false);
  };

  const getEmptyFilterPayload = () => ({
    locality: [],
    sheesha: "",
    artist: "",
    vegNonVeg: "",
    stagsAllowed: "",
    musicGenre: [],
    kidsFriendly: "",
    happyHours: "",
    liveMusicDj: "",
    artistType: "",
  });

  const clearAllData = () => {
    clearLocalities();
    clearGeneres();
    setArtist("");
    setKidsFriendly("");
    setVegNonVeg("");
    setStages("");
    setSheesha("");
    setHappyHourTimings("");
    setLiveMusicDj("");
    setArtistType("");
    // Apply immediately so parent list resets without a second Apply click
    onPressApply(getEmptyFilterPayload());
  };

  const checkAllLocality = () => {
    setSelectAllLocality(!selectAllLocality);
  };

  const checkLocalityData = (item) => {
    let temp = [...localities];
    const itemIndex = temp.findIndex((e) => e.label === item?.label);

    if (itemIndex !== -1) {
      temp[itemIndex].checked = !temp[itemIndex].checked;
      setLocalities(temp);
    }
  };

  const [selectRight, setSelectRight] = useState(
    isArtistFilter ? "Genre" : "Locality"
  );

  const checkGenreData = (genre) => {
    let temp = [...generes];
    const itemIndex = temp.findIndex((e) => e.label === genre?.label);

    if (itemIndex !== -1) {
      temp[itemIndex].checked = !temp[itemIndex].checked;
      setGeneres(temp);
    }
  };

  const checkhappyData = (index) => {
    let temp = [...happyHourTimings];
    temp[index].checked = !temp[index].checked;
    setHappyHourTimings(temp);
  };

  const happyrendarItemGenre = ({ item, index }) => {
    return <></>;
  };

  return (
    <Modal
      isOpen={isModalOpen}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Filter Modal"
      className={"filter-popup-modal"}
    >
      <div className="filter-popup">
        {/* <div
          className="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        > */}
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Filter
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={clearAllData}
              >
                {/* <span aria-hidden="true">&times;</span> */}
                Clear All
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6">
                  <div className="list-sec">
                    <ul>
                      {isArtistFilter ? (
                        <>
                          <li onClick={() => setSelectRight("Genre")}>
                            <a href="#">
                              <i className="fas fa-music"></i> Genre
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Artists")}>
                            <a href="#">
                              <i className="fas fa-music"></i> Artist
                            </a>
                          </li>
                        </>
                      ) : isEventFilter ? (
                        <>
                          <li onClick={() => setSelectRight("Locality")}>
                            <a href="#">
                              <i className="fa fa-map-marker"></i> Area
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("artistType")}>
                            <a href="#">
                              <i className="fas fa-headphones-alt"></i> Live
                              Music/DJ
                            </a>
                          </li>
                        </>
                      ) : (
                        <>
                          <li onClick={() => setSelectRight("Locality")}>
                            <a href="#">
                              <i className="fa fa-map-marker"></i> Area
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Genre")}>
                            <a href="#">
                              <i className="fas fa-music"></i> Genre
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Sheesha")}>
                            <a href="#">
                              <svg
                                id="Layer_3"
                                enableBackground="new 0 0 64 64"
                                viewBox="0 0 64 64"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="m54.05 12c-1.589 0-3.083.619-4.207 1.743l-2.843 2.843-.293-.293c-.338-.338-.867-.39-1.262-.125l-5.963 3.976c-.381-.214-.865-.175-1.189.149l-1.879 1.879c-.912.911-1.414 2.124-1.414 3.414v1l-1.064 1.064c-.192-.271-.403-.531-.643-.771l-.985-.985c.426-.519.692-1.172.692-1.894 0-.771-.301-1.468-.78-2 .48-.532.78-1.229.78-2 0-.883-.391-1.67-1-2.22v-1.88c1.194-.214 2.295-.782 3.172-1.658l1.242-1.242h.086c1.379 0 2.5-1.122 2.5-2.5s-1.121-2.5-2.5-2.5h-3.086l-.293-.293c-.59-.59-.95-1.343-1.067-2.155.582-.694.946-1.577.946-2.552v-1c0-.552-.447-1-1-1h-6c-.553 0-1 .448-1 1v1c0 .975.364 1.858.946 2.552-.117.812-.477 1.564-1.067 2.155l-.293.293h-3.086c-1.379 0-2.5 1.122-2.5 2.5s1.121 2.5 2.5 2.5h.086l1.242 1.243c.877.876 1.978 1.443 3.172 1.658v1.88c-.609.549-1 1.337-1 2.22 0 .771.301 1.468.78 2-.48.532-.78 1.229-.78 2 0 .722.266 1.375.692 1.894l-.985.985c-.24.24-.451.5-.643.771l-1.064-1.065v-1c0-1.29-.502-2.502-1.414-3.414l-1.879-1.879c-.391-.391-1.023-.391-1.414 0l-5 5c-.391.391-.391 1.023 0 1.414l1.879 1.879c.912.912 2.124 1.414 3.414 1.414h1l4.707 4.707.021-.021c.123.15.254.295.393.435l.119.119c-1.072.458-1.826 1.522-1.826 2.76 0 .883.391 1.67 1 2.22v.881c0 1.603-.624 3.109-1.757 4.243l-3.879 3.878c-1.364 1.364-2.175 3.132-2.331 5.033-4.196-1.619-7.033-5.661-7.033-10.255v-11c1.654 0 3-1.346 3-3 0-.883-.391-1.67-1-2.22v-5.56c.609-.549 1-1.337 1-2.22 0-.892-.399-1.685-1.018-2.235l-.987-9.865c-.051-.511-.481-.9-.995-.9h-2c-.514 0-.944.389-.995.9l-.986 9.865c-.62.55-1.019 1.343-1.019 2.235 0 .883.391 1.67 1 2.22v5.561c-.609.549-1 1.336-1 2.219 0 1.654 1.346 3 3 3v11c0 5.727 3.729 10.728 9.142 12.406.697 3.747 3.984 6.594 7.929 6.594h9.857c3.733 0 6.874-2.552 7.792-6h5.28c7.168 0 13-5.832 13-13v-26.05c0-3.281-2.669-5.95-5.95-5.95zm-48.05 8c0-.551.448-1 1-1h2c.552 0 1 .449 1 1s-.448 1-1 1h-2c-.552 0-1-.449-1-1zm2.095-11 .8 8h-1.79l.8-8zm.905 14v1h-2v-1zm-2 3h2v1h-2zm-1 4c0-.551.448-1 1-1h2c.552 0 1 .449 1 1s-.448 1-1 1h-2c-.552 0-1-.449-1-1zm39.873-11.713.84.841-3.268 4.903-2.475-2.475zm-8.873 7.299c0-.755.294-1.466.828-2l1.172-1.172 3.586 3.586-1.172 1.172c-.534.534-1.244.828-2 .828h-1l-1.414-1.414zm-1 2.828.586.586-1.605 1.605c-.023-.345-.077-.683-.158-1.014zm-4 10.586h-6c-.552 0-1-.449-1-1s.448-1 1-1h1 4 1c.552 0 1 .449 1 1s-.448 1-1 1zm-5-15c0-.551.448-1 1-1h2c.552 0 1 .449 1 1s-.448 1-1 1h-2c-.552 0-1-.449-1-1zm0-4c0-.551.448-1 1-1h2c.552 0 1 .449 1 1s-.448 1-1 1h-2c-.552 0-1-.449-1-1zm4-17c0 1.103-.897 2-2 2s-2-.897-2-2zm-3.276 3.772c.403.137.827.228 1.276.228s.873-.091 1.276-.228c.137.43.327.84.56 1.228h-3.674c.235-.388.425-.798.562-1.228zm-6.724 3.728c0-.276.225-.5.5-.5h15c.275 0 .5.224.5.5s-.225.5-.5.5h-15c-.275 0-.5-.224-.5-.5zm12.549 2.5c-.729.637-1.643 1-2.62 1h-3.857c-.977 0-1.891-.363-2.62-1zm-5.549 3h2v1h-2zm-1.879 12.293 1.293-1.293h.586 2 .586l1.293 1.293c.723.723 1.121 1.685 1.121 2.707s-.398 1.984-1.121 2.707l-1.293 1.293h-3.172l-1.293-1.293c-.723-.723-1.121-1.685-1.121-2.707s.398-1.984 1.121-2.707zm-3.102 2.312-1.605-1.605.586-.586 1.178 1.178c-.082.33-.136.668-.159 1.013zm-6.433-3.433-1.172-1.172 3.586-3.586 1.172 1.172c.534.534.828 1.245.828 2v1l-1.414 1.414h-1c-.756 0-1.466-.294-2-.828zm17.343 33.828h-9.857c-3.348 0-6.072-2.724-6.072-6.071 0-1.622.632-3.146 1.778-4.293l3.879-3.878c1.511-1.512 2.343-3.521 2.343-5.657v-.101h6v.101c0 2.137.832 4.146 2.343 5.657l3.879 3.878c1.146 1.147 1.778 2.671 1.778 4.293 0 3.347-2.724 6.071-6.071 6.071zm24.071-17c0 6.065-4.935 11-11 11h-5.004c0-.024.004-.047.004-.071 0-2.156-.84-4.183-2.364-5.707l-3.879-3.878c-1.133-1.134-1.757-2.641-1.757-4.243v-.881c.609-.549 1-1.337 1-2.22 0-1.238-.754-2.302-1.826-2.76l.119-.119c.139-.139.27-.284.393-.435l.021.021 4.707-4.707h1c1.29 0 2.502-.502 3.414-1.414l1.879-1.879c.324-.324.363-.808.149-1.189l3.976-5.963c.265-.396.212-.925-.125-1.262l-.293-.293 2.843-2.843c.746-.746 1.738-1.157 2.793-1.157 2.178 0 3.95 1.772 3.95 3.95z" />
                              </svg>{" "}
                              Sheesha
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Stages")}>
                            <a href="#">
                              <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 512 512"
                                style={{
                                  "enable-background": "new 0 0 512 512",
                                }}
                                xml:space="preserve"
                              >
                                <g>
                                  <g>
                                    <path d="M502.954,20.921H9.046C4.05,20.921,0,24.971,0,29.967v452.066c0,4.996,4.05,9.046,9.046,9.046h493.908 c4.996,0,9.046-4.05,9.046-9.046V29.967C512,24.971,507.95,20.921,502.954,20.921z M18.092,39.013h475.816v58.547 c-24.653,15.927-56.088,15.92-80.713-0.005V54.089c0-4.996-4.05-9.046-9.046-9.046s-9.046,4.05-9.046,9.046v43.476 c-24.644,15.912-56.056,15.906-80.689-0.012v-28.99c0-4.996-4.05-9.046-9.046-9.046c-4.996,0-9.046,4.05-9.046,9.046v29 c-24.66,15.922-56.094,15.908-80.679,0.001V68.563c0-4.996-4.05-9.046-9.046-9.046c-4.996,0-9.046,4.05-9.046,9.046v28.996 c-24.641,15.912-56.049,15.911-80.689-0.005V54.089c0-4.996-4.05-9.046-9.046-9.046s-9.046,4.05-9.046,9.046v43.475 c-24.615,15.891-55.982,15.903-80.68-0.012V39.013z M469.031,314.911c-19.9-42.346-32.006-112.583-32.68-188.915 c19.292,3.668,39.464,1.093,57.556-7.71v231.557c-35.195-3.38-68.222-26.43-93.816-65.766 c-27.28-41.929-42.842-97.223-44.179-156.475c16.757-0.206,33.466-4.976,48.25-14.332c4.528,2.863,9.239,5.283,14.072,7.29 c0.136,80.959,12.979,156.414,34.423,202.048c1.54,3.278,4.797,5.201,8.193,5.201c1.288,0,2.598-0.276,3.841-0.861 C469.213,324.821,471.155,319.433,469.031,314.911z M18.092,118.295c18.077,8.797,38.255,11.37,57.557,7.696 c-0.674,76.334-12.78,146.573-32.68,188.92c-2.124,4.522-0.181,9.909,4.34,12.035c1.244,0.584,2.552,0.861,3.842,0.861 c3.396,0,6.653-1.923,8.193-5.201c21.445-45.635,34.288-121.094,34.423-202.056c4.828-2.005,9.536-4.423,14.059-7.283 c14.796,9.356,31.509,14.122,48.262,14.328c-1.336,59.254-16.898,114.552-44.179,156.483 c-25.593,39.335-58.619,62.386-93.816,65.765V118.295z M56.67,472.985v0.001c-0.566-25.558-3.521-49.545-8.647-69.838 c-1.224-4.844-6.145-7.781-10.985-6.555c-4.844,1.223-7.778,6.142-6.555,10.985c4.699,18.6,7.517,41.541,8.088,65.407H18.092 V369.309c14.82,3.105,28.711,13.8,39.827,30.886c12.754,19.602,20.338,45.175,21.699,72.79H56.67z M369.376,472.986H142.624 v-19.068h226.751V472.986z M387.468,472.986v-28.114c0-4.995-4.05-9.045-9.046-9.045H133.578c-4.996,0-9.046,4.05-9.046,9.046 v28.114H97.705c-1.404-31.12-10.005-60.194-24.619-82.657c-7.8-11.988-16.88-21.476-26.817-28.203 c30.533-10.447,58.419-33.773,80.807-68.183c29.402-45.189,46.043-104.595,47.149-167.928c11.287-2.123,22.278-6.365,32.375-12.75 c15.139,9.574,32.278,14.357,49.415,14.355c17.137-0.001,34.268-4.786,49.37-14.353c10.104,6.39,21.104,10.633,32.397,12.756 c1.107,63.328,17.748,122.732,47.149,167.918c22.389,34.411,50.274,57.737,80.807,68.183 c-9.938,6.727-19.018,16.215-26.817,28.203c-14.615,22.463-23.215,51.537-24.619,82.657H387.468z M493.909,472.987h-20.481v-0.001 c0.573-23.864,3.39-46.806,8.089-65.407c1.224-4.844-1.71-9.762-6.555-10.985c-4.847-1.225-9.762,1.711-10.985,6.555 c-5.126,20.293-8.082,44.28-8.647,69.838h-22.948c1.36-27.615,8.946-53.188,21.699-72.79 c11.117-17.087,25.007-27.782,39.827-30.886V472.987z" />
                                  </g>
                                </g>
                              </svg>
                              Stags
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Veg/Non Veg")}>
                            <a href="#">
                              <i className="fas fa-utensils"></i> Veg/Non-Veg
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Happy Hours")}>
                            <a href="#">
                              <i className="fas fa-beer"></i> Happy Hours
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("Kids Friendly")}>
                            <a href="#">
                              <i className="fas fa-baby"></i> Kids Friendly
                            </a>
                          </li>
                          <li onClick={() => setSelectRight("liveMusicDj")}>
                            <a href="#">
                              <i className="fas fa-headphones-alt"></i> Live
                              Music/DJ
                            </a>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="list-wrapper">
                    {selectRight === "Locality" ? (
                      <>
                        <div className="search-colm">
                          <i className="fa fa-search"></i>
                          <input
                            type="search"
                            name=""
                            placeholder="Search"
                            value={searchLocality}
                            onChange={(event) =>
                              setSearchLocality(event.target.value)
                            }
                          />
                        </div>
                        <div className="check-list">
                          <li className="item all" onClick={checkAllLocality}>
                            <input
                              type="checkbox"
                              checked={selectAllLocality ? true : false}
                              aria-label="Checkbox for following text input"
                              readOnly
                            />
                            Select All
                          </li>
                          {localities
                            ?.filter((e) =>
                              matchesFilterSearch(e.label, searchLocality)
                            )
                            .map((locality, index) => (
                              <li
                                className="item"
                                key={index.toString()}
                                onClick={() => checkLocalityData(locality)}
                              >
                                <input
                                  type="checkbox"
                                  checked={locality?.checked ? true : false}
                                  aria-label="Checkbox for following text input"
                                />
                                {locality?.label}
                              </li>
                            ))}
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Genre" ? (
                      <>
                        <div className="search-colm">
                          <i className="fa fa-search"></i>
                          <input
                            type="search"
                            name=""
                            placeholder="Search"
                            value={searchGenre}
                            onChange={(event) =>
                              setSearchGenre(event.target.value)
                            }
                          />
                        </div>
                        <div className="check-list">
                          {(
                            generes?.filter((e) =>
                              matchesFilterSearch(e.label, searchGenre)
                            ) || []
                          ).map((genre, index) => (
                            <li
                              className="item"
                              key={index.toString()}
                              onClick={() => checkGenreData(genre)}
                            >
                              <input
                                type="checkbox"
                                aria-label="Checkbox for following text input"
                                checked={genre?.checked ? true : false}
                              />
                              {genre?.label}
                            </li>
                          ))}
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Artists" ? (
                      <>
                        <div className="check-list">
                          <li className="item" onClick={() => setArtist("dj")}>
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={artist === "dj" ? true : false}
                            />
                            DJ
                          </li>
                          <li
                            className="item"
                            onClick={() => setArtist("artist")}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={artist === "artist" ? true : false}
                            />
                            SINGER
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Sheesha" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (sheesha === "yes") {
                                setSheesha("");
                              } else {
                                setSheesha("yes");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={sheesha === "yes" ? true : false}
                            />
                            Yes
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (sheesha === "no") {
                                setSheesha("");
                              } else {
                                setSheesha("no");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={sheesha === "no" ? true : false}
                            />
                            No
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Stages" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (sheesha === "yes") {
                                setStages("");
                              } else {
                                setStages("yes");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={stages === "yes" ? true : false}
                            />
                            Yes
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (sheesha === "no") {
                                setStages("");
                              } else {
                                setStages("no");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={stages === "no" ? true : false}
                            />
                            No
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Veg/Non Veg" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (vegNonVeg === "veg") {
                                setVegNonVeg("");
                              } else {
                                setVegNonVeg("veg");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={vegNonVeg === "veg" ? true : false}
                            />
                            Veg
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (vegNonVeg === "non-veg") {
                                setVegNonVeg("");
                              } else {
                                setVegNonVeg("non-veg");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={vegNonVeg === "non-veg" ? true : false}
                            />
                            Non-Veg
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Happy Hours" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (happyHourTimings === "yes") {
                                setHappyHourTimings("");
                              } else {
                                setHappyHourTimings("yes");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={
                                happyHourTimings === "yes" ? true : false
                              }
                            />
                            Yes
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (happyHourTimings === "no") {
                                setHappyHourTimings("");
                              } else {
                                setHappyHourTimings("no");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={happyHourTimings === "no" ? true : false}
                            />
                            No
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "Kids Friendly" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (kidsFriendly === "yes") {
                                setKidsFriendly("");
                              } else {
                                setKidsFriendly("yes");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={kidsFriendly === "yes" ? true : false}
                            />
                            Yes
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (kidsFriendly === "no") {
                                setKidsFriendly("");
                              } else {
                                setKidsFriendly("no");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={kidsFriendly === "no" ? true : false}
                            />
                            No
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "liveMusicDj" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (liveMusicDj === "LM") {
                                setLiveMusicDj("");
                              } else {
                                setLiveMusicDj("LM");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={liveMusicDj === "LM" ? true : false}
                            />
                            Live Music
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (liveMusicDj === "DJ") {
                                setLiveMusicDj("");
                              } else {
                                setLiveMusicDj("DJ");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={liveMusicDj === "DJ" ? true : false}
                            />
                            DJ
                          </li>
                        </div>
                      </>
                    ) : null}
                    {selectRight === "artistType" ? (
                      <>
                        <div className="check-list">
                          <li
                            className="item"
                            onClick={() => {
                              if (artistType === "singer") {
                                setArtistType("");
                              } else {
                                setArtistType("singer");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={artistType === "singer" ? true : false}
                            />
                            Live Music
                          </li>
                          <li
                            className="item"
                            onClick={() => {
                              if (artistType === "dj") {
                                setArtistType("");
                              } else {
                                setArtistType("dj");
                              }
                            }}
                          >
                            <input
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={artistType === "dj" ? true : false}
                            />
                            DJ
                          </li>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn close"
                data-dismiss="modal"
                onClick={onPressCancel}
              >
                Close
              </button>
              <button
                type="button"
                className="btn apply"
                onClick={() => {
                  var tempdata = [];
                  for (var i = 0; i < localities?.length; i++) {
                    if (localities[i].checked == true) {
                      tempdata.push(localities[i]);
                    }
                  }
                  var tempdataGenres = [];
                  for (var i = 0; i < generes?.length; i++) {
                    if (generes[i].checked == true) {
                      tempdataGenres.push(generes[i]);
                    }
                  }

                  onPressApply({
                    locality: tempdata,
                    sheesha: sheesha,
                    artist: artist,
                    vegNonVeg: vegNonVeg,
                    stagsAllowed: stages,
                    musicGenre: tempdataGenres,
                    kidsFriendly: kidsFriendly,
                    happyHours: happyHourTimings,
                    liveMusicDj: liveMusicDj,
                    artistType: artistType,
                  });
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </Modal>
  );
};

export default memo(FilterComp);
